import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { FileService } from '../services/file.service';

@Directive({
  selector: '[loadHtmlFromUrl]'
})
export class LoadHtmlFromUrlDirective implements OnInit {
  @Input('loadHtmlFromUrl') Url: string = '';

  constructor(private el: ElementRef,
    private fileService: FileService
  ) { }

  ngOnInit(): void {
    this.loadHtml(this.Url);
  }

  private async loadHtml(url: string) {
    try {
        this.fileService.getFileDataTextByUrl(url).subscribe(resp => {
            this.el.nativeElement.innerHTML = resp;
        });
    } catch (error) {
      console.error('Error cargando HTML:', error);
    }
  }
}